import { array, object, string } from 'yup';
import { requiredDuration } from '@travelity/form/controls';
import type { RouteItem } from '@travelity/api/services';
import {
    combineArrivalStopDuration,
    durationToMinutes,
} from './product-route-form.utils';

const schema = object({
    stops: array()
        .of(object())
        .when(['repeatLocation'], (arr, sch, { value }) => {
            if (!value || value.length === 0) {
                return sch.min(1, 'Route must have at least 1 stop');
            }
            if (value[0].repeatLocation) {
                return sch;
            }
            return sch.min(2, 'Route must have at least 2 stops');
        })
        .notInEdit(),
});

export default schema;

export const productRouteFormSchema = object({
    name: string().required('Name is a required field').uniqName().defined(),
    arrivalOffset: object()
        .when(['$items', 'id'], ([items, id], sch) => {
            const currentIndex = items.findIndex((i: any) => i.id === id);
            return currentIndex > 0 ? requiredDuration : sch;
        })
        .when(['$items', 'id'], (values, sch, { value }) => {
            const [items, id] = values as [RouteItem[], string];
            const index = items.findIndex(i => i.id === id);

            const current = durationToMinutes(value);

            const prev = items[index - 1];
            const next = items[index + 1];

            return sch.test(
                'range-check',
                'Arrival offset must be greater than previous and smaller than next',
                () => {
                    if (!prev) return true;
                    if (prev && next) {
                        const prevMin = combineArrivalStopDuration(
                            prev.arrivalOffset,
                            prev.duration
                        );
                        const currentWithStop = combineArrivalStopDuration(
                            value,
                            items[index].duration
                        );
                        const nextMax = durationToMinutes(next.arrivalOffset);

                        if (
                            currentWithStop > prevMin &&
                            currentWithStop < nextMax
                        )
                            return true;
                    }
                    if (prev) {
                        const prevMin = combineArrivalStopDuration(
                            prev.arrivalOffset,
                            prev.duration
                        );

                        if (current >= prevMin) return true;
                    }

                    return false;
                }
            );
        }),
});
